import { useEffect, useState } from 'react';
import { HAS_WINDOW } from './has-window';

/**
 * This function allows us to detect if we are on SSR or CSR
 * based on nature of useEffect that is only executed after
 * mounting. Mount is only performed in CSR
 * @returns isSsr {boolean}
 */
export const useIsSsr = (): boolean => {
    const [isSsr, setIsSsr] = useState(!HAS_WINDOW);

    useEffect(() => {
        setIsSsr(false);
    }, []);

    return isSsr;
};
